import { Api as api } from "../../api";
const prefix = '/master-data'
// const prefix = ''

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    stateServiceV1GetStatesByCountryId: build.query<
      StateServiceV1GetStatesByCountryIdApiResponse,
      StateServiceV1GetStatesByCountryIdApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/countries/${queryArg.countryId}/states`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
    }),
    stateServiceV1GetCitiesByStateId: build.query<
      StateServiceV1GetCitiesByStateIdApiResponse,
      StateServiceV1GetCitiesByStateIdApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/states/${queryArg.stateId}/cities`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as statesApi };
export type StateServiceV1GetStatesByCountryIdApiResponse =
  /** status 200 A successful response. */ StateV1GetStatesByCountryIdRes;
export type StateServiceV1GetStatesByCountryIdApiArg = {
  countryId: string;
  page?: number;
  limit?: number;
};
export type StateServiceV1GetCitiesByStateIdApiResponse =
  /** status 200 A successful response. */ StateV1GetCitiesByStateIdRes;
export type StateServiceV1GetCitiesByStateIdApiArg = {
  stateId: string;
  page?: number;
  limit?: number;
};
export type StateV1StateItem = {
  id?: string;
  name?: string;
};
export type StateV1StatePaginationMeta = {
  current_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
  limit?: number;
  total?: number;
  total_page?: number;
};
export type StateV1GetStatesByCountryIdRes = {
  states?: StateV1StateItem[];
  metadata?: StateV1StatePaginationMeta;
};
export type ProtobufAny = {
  /** Identifies the type of the serialized Protobuf message with a URI reference
    consisting of a prefix ending in a slash and the fully-qualified type name.
    
    Example: type.googleapis.com/google.protobuf.StringValue
    
    This string must contain at least one `/` character, and the content after
    the last `/` must be the fully-qualified name of the type in canonical
    form, without a leading dot. Do not write a scheme on these URI references
    so that clients do not attempt to contact them.
    
    The prefix is arbitrary and Protobuf implementations are expected to
    simply strip off everything up to and including the last `/` to identify
    the type. `type.googleapis.com/` is a common default prefix that some
    legacy implementations require. This prefix does not indicate the origin of
    the type, and URIs containing it are not expected to respond to any
    requests.
    
    All type URL strings must be legal URI references with the additional
    restriction (for the text format) that the content of the reference
    must consist only of alphanumeric characters, percent-encoded escapes, and
    characters in the following set (not including the outer backticks):
    `/-.~_!$&()*+,;=`. Despite our allowing percent encodings, implementations
    should not unescape them to prevent confusion with existing parsers. For
    example, `type.googleapis.com%2FFoo` should be rejected.
    
    In the original design of `Any`, the possibility of launching a type
    resolution service at these type URLs was considered but Protobuf never
    implemented one and considers contacting these URLs to be problematic and
    a potential security issue. Do not attempt to contact type URLs. */
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type StateV1CityItem = {
  id?: string;
  name?: string;
};
export type StateV1GetCitiesByStateIdRes = {
  cities?: StateV1CityItem[];
  metadata?: StateV1StatePaginationMeta;
};
export const {
  useStateServiceV1GetStatesByCountryIdQuery,
  useStateServiceV1GetCitiesByStateIdQuery,
} = injectedRtkApi;